module.exports = __webpack_public_path__ + "static/media/cl_logo_white.fa6779c5.webp";